<template>
  <li :class="[eventClass, calendarTime]" @click.prevent="detectEventAction">
    <template v-if="eventType === 'live'">
      <img :src="liveBgImageSrc" class="img-preload" @load="imageLoaded = true">
      <div class="img-wrap" :class="{'visible': itemVisible}" :style="{'backgroundImage': bgImage}"/>
    </template>
    <template v-else>
      <div class="img-wrap" :class="{'visible': itemVisible}" :style="{'backgroundImage': bgImage}"/>
    </template>

    <template v-if="item.time">
      <p>{{ formatedDate }}</p>
    </template>

    <transition name="fade">
      <div v-if="itemVisible && !item.time">
        <div class="description">
          <progress-bar v-if="eventType === 'live'"
            :startTime="startTimeTimestamp"
            :endTime="endTimeTimestamp"
            :type="eventType"
            :reloadMarker="reloadMarker"
          />
          <p class="event-subtitle">{{ getHoursMinutes }}</p>
          <p class="event-title">{{ item.title }}</p>
        </div>
        <div v-if="eventType === 'live'" class="play-action">
          <img src="~assets/images/icons/play-2.png" class="play-gridview">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 30 30" class="play-listview"><path d="M14.997,30.001 C6.713,30.001 -0.003,23.284 -0.003,15.000 C-0.003,6.715 6.713,-0.001 14.997,-0.001 C23.282,-0.001 29.998,6.715 29.998,15.000 C29.998,23.284 23.282,30.001 14.997,30.001 ZM14.997,1.304 C7.433,1.304 1.301,7.436 1.301,15.000 C1.301,22.564 7.433,28.696 14.997,28.696 C22.561,28.696 28.693,22.564 28.693,15.000 C28.693,7.436 22.561,1.304 14.997,1.304 ZM11.073,22.694 C10.502,23.026 9.785,22.610 9.785,21.945 L9.785,8.038 C9.785,7.373 10.502,6.957 11.073,7.290 L23.039,14.243 C23.610,14.576 23.610,15.407 23.039,15.740 L11.073,22.694 Z"/></svg>
        </div>
      </div>
    </transition>
    <div class="marker live-marker" v-if="eventType === 'live'"></div>
  </li>
</template>

<script>
import ProgressBar from 'components/ProgressBar'
import DateTimeHelper from 'helpers/date'
import { getThumbnailImagePath } from 'helpers/images'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { getEonUrl } from 'helpers/baseURLhelper'

export default {
  name: 'Event',
  components: {
    ProgressBar
  },
  props: {
    item: Object,
    partsOfDay: Object,
    reloadMarker: Function,
    showEvents: Function
  },
  data () {
    return {
      imageLoaded: false
    }
  },
  computed: {
    ...mapState({
      currentEvent: state => state.guide.currentEvent
    }),
    ...mapGetters([
      'nowTime'
    ]),
    startTimeTimestamp () {
      return DateTimeHelper.toTimestamp(this.item.startTime)
    },
    endTimeTimestamp () {
      return DateTimeHelper.toTimestamp(this.item.endTime)
    },
    eventType () {
      return DateTimeHelper.getEventType(this.startTimeTimestamp, this.endTimeTimestamp, this.nowTime)
    },
    eventClass: function () {
      return {
        event: !this.isDate,
        date: this.isDate,
        'live-event': this.eventType === 'live'
      }
    },
    calendarTime () {
      if (this.isDate) {
        return 'morning--' + DateTimeHelper.format(this.item.time, 'YYYY-MM-DD')
      }
      for (let i in this.partsOfDay) {
        let part = this.partsOfDay[i]
        if (part.timeStart <= DateTimeHelper.format(this.item.startTime, 'HH:mm') &&
            part.timeEnd >= DateTimeHelper.format(this.item.endTime, 'HH:mm')) {
          return i + '--' + DateTimeHelper.format(this.item.startTime, 'YYYY-MM-DD')
        }
      }
    },
    itemVisible: function () {
      return this.item.itemVisible
    },
    bgImage: function () {
      return `url(${getThumbnailImagePath(this.item.images)})`
    },
    liveBgImageSrc: function () {
      return getThumbnailImagePath(this.item.images)
    },
    formatedDate: function () {
      return DateTimeHelper.formatTimestamp(this.item.time, 'dddd, DD. MMMM YYYY')
    },
    isDate: function () {
      if (this.item.time) {
        return true
      }
    },
    getHoursMinutes: function () {
      return DateTimeHelper.getHoursMinutes(this.item.startTime)
    },
    hidePageLoader: function () {
      return this.itemVisible && this.imageLoaded
    }
  },
  methods: {
    detectEventAction: async function (e) {
      // Detect clicked action
      if (e.target.classList.contains('play-gridview') ||
          e.target.classList.contains('play-listview')) {
        window.open(`${getEonUrl()}/player/${this.item.channelId}`, '_blank')
      } else {
        // Get selected event
        await this.getEvent(this.item.id)

        // Open event detail modal
        this.SET_MODAL_TYPE('detail')
        this.UPDATE_SHOW_MODAL(true)
      }
    },
    ...mapMutations([
      'UPDATE_IS_LOADING',
      'UPDATE_SHOW_MODAL',
      'SET_MODAL_TYPE',
      'SET_MODAL_DATA'
    ]),
    ...mapActions([
      'getEvent'
    ])
  },
  watch: {
    hidePageLoader: function (value) {
      if (value) {
        this.UPDATE_IS_LOADING(false)
        this.showEvents()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import 'uc/_variables';

.date {
    height: 1px;
    overflow: hidden;

    p {
        text-transform: capitalize;
        margin-top: 30px;
        margin-bottom: 0;
        padding: 8px 22px;
        font-size: 13px;
        color: rgb(0, 149, 218);
        border: 1px solid rgb(229, 229, 229);
    }
}

.event {
    height: 24vw;
    max-height: 460px;
    margin-bottom: 15px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
    position: relative;
    background-image: url(~assets/images/photos/tv_guide_placeholder_1200x675.png);

    /*&:before {*/
        /*content: '';*/
        /*position: absolute;*/
        /*left: 0;*/
        /*bottom: 0;*/
        /*width: 100%;*/
        /*height: 50%;*/
        /*background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);*/
    /*}*/
}

.img-preload {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.img-wrap {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: cover;
    opacity: 0;
    transition: opacity 0.3s ease;
    position: relative;

    &.visible {
        opacity: 1;
    }

    &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);
    }
}

.description {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 90px;
    padding: 12px 20px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
}

.play-action {
    position: absolute;
    top: 50%;
    margin-top: -36px;
    left: 0;
    right: 0;
    width: 72px;
    margin-left: auto;
    margin-right: auto;
    // pointer-events: none;
}
.play-gridview {
    display: block;
    opacity: 0.8;
    width: 72px;
    height: 72px;
    transition: opacity 300ms;
    // pointer-events: auto;

    &:hover {
        opacity: 1;
    }
}
.play-listview {
    display: none;
    width: 24px;
    height: 24px;
    fill: #a7a7a7;
    transition: fill 0.3s ease;

    path {
        pointer-events: none;
    }
    &:hover {
        fill: rgb(0, 149, 218);
    }
}

.event-subtitle {
    margin-bottom: 0;
    font-size: 13px;
    font-weight: bold;
    color: #fff;
}

.event-title {
    margin-bottom: 0;
    line-height: 28px;
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 300;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.list-view {
    .date {
        height: auto;
    }
    .event {
        height: 43px;
        margin-bottom: 0;
        padding-top: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgb(229, 229, 229);
        background: transparent;

        &:before {
            display: none;
        }
    }
    .img-wrap {
        display: none;
    }
    .description {
        position: static;
        height: auto;
        padding: 0;
        background: none;
    }
    .progress-wrap {
        top: auto;
        bottom: 0;
        height: 2px;
        background-color: transparent;
    }
    .event-subtitle {
        float: left;
        width: 60px;
        line-height: 18px;
        font-size: 18px;
        font-weight: 300;
        color: black;
    }
    .event-title {
        text-transform: none;
        font-size: 16px;
        line-height: 20px;
        color: black;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .play-action {
        left: auto;
        width: auto;
        margin-top: -12px;
    }
    .play-gridview {
        display: none;
    }
    .play-listview {
        display: block;
    }
    .marker {
        bottom: -16px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

// Marker
.marker {
    width: 44px;
    height: 34px;
    position: absolute;
    background: url(~assets/images/icons/marker.png) 0 0 no-repeat;
    background-size: 100%;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    line-height: 32px;
    padding-left: 4px;
    z-index: 1;
    position: absolute;
    bottom: 70px;
    left: -17px;
    visibility: hidden;
        &.visible {
           visibility: visible;
        }
}

@media only screen and (max-width: $breakpoint1) {
    .event {
        height: 245px;
    }
}

@media only screen and (min-width: $breakpoint3) {
    .play-action {
      width: 100px;
      margin-top: -50px;
    }

    .play-gridview {
        width: 100px;
        height: 100px;
    }
    .play-listview {
        width: 30px;
        height: 30px;
    }

    .list-view {
        .date {
            p {
                font-size: 18px;
                padding: 10px 30px;
            }
        }
        .event {
            height: 63px;
            padding-top: 16px;
            padding-bottom: 16px;
        }
        .progress-wrap {
            height: 3px;
        }
        .event-subtitle {
            width: 74px;
            font-size: 23px;
            line-height: 32px;
        }
        .event-title {
            font-size: 20px;
            line-height: 32px;
        }
        .play-action {
            margin-top: -15px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/Event.vue